import React from 'react'
import ReactDOM from 'react-dom/client'
import { UserManager, WebStorageStateStore } from 'oidc-client-ts'
import App from './App.tsx'
import { loadConfig, config, isAuthConfigured } from './config'
import './index.css'

async function handleOidcCallback(): Promise<void> {
  const params = new URLSearchParams(window.location.search);
  if (!params.has('code') || !params.has('state')) return;
  if (!isAuthConfigured()) return;

  const mgr = new UserManager({
    authority: config.auth.authority,
    client_id: config.auth.clientId,
    redirect_uri: config.auth.redirectUri,
    scope: config.auth.scopes,
    response_type: 'code',
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  });

  await mgr.signinRedirectCallback(window.location.href);
  window.history.replaceState({}, '', window.location.pathname + window.location.hash);
}

async function bootstrap() {
  await loadConfig();
  await handleOidcCallback();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

bootstrap();
